export default __webpack_public_path__ + "static/media/15.bd792af8.jpg";